import { render, staticRenderFns } from "./Page500.vue?vue&type=template&id=200d2f71&"
import script from "./Page500.vue?vue&type=script&lang=js&"
export * from "./Page500.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\yuichi\\git\\open_coupon\\public\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('200d2f71')) {
      api.createRecord('200d2f71', component.options)
    } else {
      api.reload('200d2f71', component.options)
    }
    module.hot.accept("./Page500.vue?vue&type=template&id=200d2f71&", function () {
      api.rerender('200d2f71', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Page500.vue"
export default component.exports